import { render, staticRenderFns } from "./DownloadCouponList.vue?vue&type=template&id=1005319e&scoped=true"
import script from "./DownloadCouponList.vue?vue&type=script&lang=js"
export * from "./DownloadCouponList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1005319e",
  null
  
)

export default component.exports